import { render, staticRenderFns } from "./InvestidorEdit.vue?vue&type=template&id=39137584&scoped=true"
import script from "./InvestidorEdit.vue?vue&type=script&lang=js"
export * from "./InvestidorEdit.vue?vue&type=script&lang=js"
import style0 from "./InvestidorEdit.vue?vue&type=style&index=0&id=39137584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39137584",
  null
  
)

export default component.exports